import { Component, Input } from '@angular/core';

@Component({
  selector: 'itfg-dpd-calendar',
  template: `
    <div class="dpd-calendar">
      <div *ngFor="let status of dpdArray; let i = index"
           class="dpd-box"
           [style.background-color]="getColor(status)"
           [title]="getTooltip(i, status)">
        {{ status }}
      </div>
    </div>
  `,
  styles: [`
    .dpd-calendar {
      display: flex;
      gap: 4px;
      flex-wrap: nowrap;
    }

    .dpd-box {
      width: 24px;
      height: 24px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 11px;
      font-weight: 600;
      cursor: help;
      flex-shrink: 0;
    }
  `],
  standalone: false
})
export class DpdCalendarComponent {
  @Input() dpdCal: string = '';
  @Input() size: 'small' | 'medium' = 'small'; // optional sizing

  private months = ['Ян', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Ное', 'Дек'];

  get dpdArray(): string[] {
    return this.dpdCal.split('');
  }

  getColor(status: string): string {
    const colors: Record<string, string> = {
      '=': '#10b981',
      'B': '#fbbf24',
      'C': '#fb923c',
      'D': '#ef4444',
      'E': '#b91c1c',
      'F': '#7f1d1d',
      '-': '#e5e7eb'
    };
    return colors[status] || colors['-'];
  }

  getTooltip(index: number, status: string): string {
    const labels: Record<string, string> = {
      '=': '0-30 дни',
      'B': '31-60 дни',
      'C': '61-90 дни',
      'D': '91-180 дни',
      'E': '181-360 дни',
      'F': 'над 360 дни',
      '-': 'няма данни'
    };
    return `${this.months[index]}: ${labels[status] || labels['-']}`;
  }
}